export var HttpClientAuthType;
(function (HttpClientAuthType) {
    HttpClientAuthType[HttpClientAuthType["Normal"] = 0] = "Normal";
    HttpClientAuthType[HttpClientAuthType["Windows"] = 1] = "Windows";
    HttpClientAuthType[HttpClientAuthType["Basic"] = 2] = "Basic";
})(HttpClientAuthType || (HttpClientAuthType = {}));
;
